import React, {Component} from "react";
import * as PropTypes from "prop-types";
import {Badge, Icon, Popover, Select, Tooltip} from "antd";
import {items} from "../../index";
import {ItemSmall, rankMap} from "./ItemSmall";
import {connect} from "react-redux";
import {setItem, setPosition, setVisible} from "../ducks/itemhint";
import './ItemSlot.less';
import {ItemHint} from "./ItemHint";
import {SlotNames} from "../CharacterSummary";

const ICON_WIDTH = 50;
const ICON_HEIGHT = 50;

export const itemImageUrl = name => `url("https://github.com/sfarmani/twicons/raw/master/${encodeURIComponent(name)}.jpg")` ;

export const ItemIcon = ({width = ICON_WIDTH, height = ICON_HEIGHT, position = 'static', top, left, icon, ...rest}) => <a
  {...rest}
  className={'item-icon ' + (rest.className || '')}
  style={{
    width, height,
    backgroundImage: icon ? itemImageUrl(icon) : 'url("/tw-builder/null.png")',
    ...rest.style,
  }}
/>;

const SlotOption = ({option}) => <div className='dropdown-item'>
  <ItemIcon icon={option.name} width={26} height={26} style={{marginRight: 8}}/>
  <ItemSmall inline name={option.name}/>
  <span className='extra'>{option.level}</span>
</div>;

SlotOption.propTypes = {option: PropTypes.any};

const itemCompare = (a, b) => {
  const rank = o => rankMap[o.rank].order;
  return rank(a) - rank(b) || a.grade - b.grade || a.level - b.level || a.name.localeCompare(b.name);
};

export const SlotSelection = ({item, type, slot, handleSelectItem, children}) => {
  const slotItems = items
    .filter(match => type.some(type => match.type.includes(type)))
    .sort(itemCompare);
  return <Popover
    trigger='click'
    placement='rightTop'
    content={<Select
      className='dropdown-selection'
      showSearch
      allowClear
      dropdownMatchSelectWidth={false}
      onSelect={handleSelectItem(slot)}
      onChange={v => !v && handleSelectItem(slot)(null)}
      value={item || null}
    >
      <Select.Option value={null}>Select an item or type here to search...</Select.Option>
      {slotItems.map(option =>
        <Select.Option key={option.name}><ItemHint name={option.name}><SlotOption option={option}/></ItemHint></Select.Option>
      )}
    </Select>}
  >
    {children}
  </Popover>;
};

class _ItemSlot extends Component {
  handleMouseOver = () => {
    const {equipped, slot, setItem, setVisible} = this.props;
    const item = equipped[slot];
    setVisible && setVisible(true);
    setItem && setItem(item);
  };

  handleMouseOut = () => {
    const {setVisible} = this.props;
    setVisible && setVisible(false);
  };

  handleMouseMove = ({clientX: x, clientY: y}) => {
    const {onMouseMove} = this.props;
    onMouseMove && onMouseMove({x, y});
  };

  render() {
    const {top, left, slot, character, equipped} = this.props;

    const type = character[slot];
    const item = equipped[slot];

    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        width: 100,
        height: 70,
        alignItems: 'center',
        position: 'absolute',
        top: top - (ICON_HEIGHT/2) - 18,
        left: left - 50,
      }}>
        <div>{SlotNames[slot]}</div>
        {item && <Badge onClick={() => this.props.handleSelectItem(slot)(null)} count={
            <span style={{position: 'absolute', top: -1, left: 14, cursor: 'pointer'}}>
              <Icon type='close-circle' theme='twoTone' className='close-circle close-circle-background-large' twoToneColor='#ffeae6'/>
              <Tooltip title='Clear Item'>
              <Icon type='close-circle' theme='twoTone' className='close-circle' twoToneColor='#d41414'/>
              </Tooltip>
            </span>
        }/>}
        <SlotSelection type={type} slot={slot} item={item} handleSelectItem={this.props.handleSelectItem}>
          <ItemIcon position='absolute' top={top} left={left} icon={item}
                    onMouseOver={this.handleMouseOver}
                    onMouseOut={this.handleMouseOut}
                    onMouseMove={this.handleMouseMove}
          />
        </SlotSelection>
      </div>
    );
  }
}

export const ItemSlot = connect(
  null,
  (dispatch, props) => ({
    onMouseMove: ({x, y}) => dispatch(setPosition({x, y})),
    setVisible: visible => dispatch(setVisible(visible)),
    setItem: name => dispatch(setItem(name)),
  }),
)(_ItemSlot);

ItemSlot.propTypes = {
  top: PropTypes.number,
  left: PropTypes.number,
  slot: PropTypes.string,
  character: PropTypes.object,
  equipped: PropTypes.string,
  handleSelectItem: PropTypes.func,
};
